module.exports = __webpack_public_path__ + "img/p_sz_2.2532f30c.png";